var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "my-base-picker"
  }, [_c("Popover", {
    attrs: {
      placement: "bottom-start",
      trigger: "click",
      disabled: _vm.disabled,
      "popper-class": _vm.popperClass,
      width: _vm.popoverWidth
    },
    on: {
      show: _vm.handleShow,
      hide: _vm.handleHide
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    ref: "reference",
    class: _vm.refClass,
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_vm._t("reference")], 2), _vm._t("default", null, {
    visible: _vm.visible
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };